module.exports = __webpack_public_path__ + "static/media/wetCrabappleBlossoms.fbb798fa.jpg";